<template>
    <h1>logout</h1>
</template>

<script>

    

    export default {
        name: 'Logout',
        mounted() {
           console.log('asdfasd');
           this.logout();
        },    

        methods: {
            logout() {

                    console.log('logout');
                    this.$userService.logout();

                    this.$router.push({ name: 'login'}, () => {
                        return
                    });
                
            }
        }
    }
</script>

<style scoped>
    #logout {
        width: 500px;
        border: 1px solid #CCCCCC;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 200px;
        padding: 20px;
    }
</style>